import React, { FC, memo, ReactNode } from 'react';
import styles from './share-button.module.css';

export interface ShareButtonProps {
  icon: ReactNode;
  shareUrl: string;
  ariaLabel: string;
}

export const ShareButton: FC<ShareButtonProps> = memo(
  ({ icon, shareUrl, ariaLabel }) => {
    const handleShare = () => {
      window.open(shareUrl, '_blank');
    };

    return (
      <button
        className={styles.button}
        onClick={() => handleShare()}
        aria-label={ariaLabel}
      >
        {icon}
      </button>
    );
  },
);

ShareButton.displayName = 'ShareButton';
